import React, { useState } from 'react';
import Tabs from '../Tabs/Tabs';
import EditorContainerProfile from '../EditorContainerProfile/EditorContainerProfile';
import { categoriesFieldProfile } from '../../constants/categoriesField';
import './ProfileContainerContact.css';
import GeneralInfoButtons from '../GeneralInfoButtons/GeneralInfoButtons';
const ProfileContainerContact = ({
  formData,
  handleChangeFormData,
  isFormChanged,
  isFormValid,
  handleDataProfileUpdate,
  handleCancel,
}) => {
  const [tabs, setTabs] = useState([
    { id: 'contacts', value: 'Контактная информация', active: true },
  ]);
  const [selectedTab, setSelectedTab] = useState(
    tabs.find((tab) => tab.active)?.id || 'contacts'
  );

  const handleTabSelected = (e) => {
    const clickedId = e.currentTarget.dataset.id;
    setTabs((prev) =>
      prev.map((item) => ({
        ...item,
        active: item.id === clickedId,
      }))
    );
    setSelectedTab(clickedId);
  };
  return (
    <div className='profile-container-contact'>
      <h2 className='profile-container-contact__header'>
        <Tabs handleTabSelected={handleTabSelected} tabs={tabs} />
      </h2>
      {selectedTab === 'contacts' && (
        <div>
          <EditorContainerProfile
            formData={formData} // Передаём обновляемые данные
            categories={categoriesFieldProfile}
            handleChangeFormData={handleChangeFormData} // Передаём обработчик
            canEdit={true}
          />
          <GeneralInfoButtons
            isFormChanged={isFormChanged}
            isFormValid={isFormValid}
            onSave={handleDataProfileUpdate}
            onCancel={handleCancel}
          />
        </div>
      )}
    </div>
  );
};

export default ProfileContainerContact;
